import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import ClientService from './../../../clientmanagement/services/clientmanagement.service';
import MasterService from './../../../masterdata/services/masterdata.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'ClientHubs',
  components: {
    VueElementLoading,
    Treeselect,
    Multiselect
  },
  data: function() {
    return {
      mpsNo:"",
      isLoading: false,
      client :null,
      hubids:[],
      Clientlist:[],
      HubList:[],
      RouteMode:'',
      selectAll:false,
      clienterr:'',
      huberror:''
    }
  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.getCompanyShortName();
    this.getHublist();
   },
  methods: {
    async getCompanyShortName(){
      try {
        let InputPayload = {};
        var CompanyShortList = [];
        let result = await ClientService.GetClientListByActiveContracts(InputPayload);
        CompanyShortList = result.data.data.rows;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.Clientlist.push({
          'id': CompanyShortList[i].clientid,
          'label': CompanyShortList[i].clientshortname,
          'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid
          });
        }
      } catch(err){
          this.isLoading = false;
          this.$alert(err, "", "error");
          console.log(err);
      }
    },
    selectClient(data){
      if(data){
        this.clientbusinessaccountid = data.ClientBusinessAccountId;
        this.getClientHubs(data.id);
      }
    },
    async getHublist() {
      try {
        let InputPayload = {};
        let result = await MasterService.GetHublist(InputPayload);
        let hublist = result.data.data.data;
        for (var i = 0; i < hublist.length; i++) {
          this.HubList.push({
          'HubID': hublist[i].HubID,
          'HubName': hublist[i].HubName
          });
        }
        return this.HubList;
      } catch (err) {
        console.log(err);
      }
    },
    validateform(){
      this.$validator.validateAll("clienthubform").then((result) => {
        if(result){
          this.saveClientHubs();
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
   async selectAllHubs(){
      if(this.selectAll == true)
      {
        this.hubids=this.HubList;
      }else
      {
        this.hubids=[];
      }
    },
    async saveClientHubs(){
      try {
        if (this.isCheck()) {
          return false
        }
        this.isLoading = true;
        let tempArr = [];
        for(var i =0; i<this.hubids.length; i++){
  				tempArr.push(this.hubids[i].HubID);
  			}
        let inputPayload = {};
        inputPayload.clientid = this.client.id;
        inputPayload.clientbusinessaccountid = this.clientbusinessaccountid;
        inputPayload.clientname = this.client.label;
        inputPayload.hubids = tempArr;
        inputPayload.lastmodifiedby = this.userName;
        let result = await ClientService.saveClientHubs(inputPayload);
        if (result.data.code == 200) {
          this.$alert(result.data.message, "", "success");
        }else{
          this.$alert(result.data.message, "", "error");
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    getHubName(hubid) {
      for (var i = 0; i < this.HubList.length; i++) {
        if (this.HubList[i].HubID == hubid) {
          return this.HubList[i].HubName;
        }
      }
    },
    async getClientHubs(id){
      try {
        this.isLoading = true;
        this.hubids = [];
        let inputPayload = {};
        inputPayload.clientid = id;
        inputPayload.clientbusinessaccountid = this.clientbusinessaccountid;
        let result = await ClientService.getClientHubs(inputPayload);
        if(result.data.data){
          let tempHubids = result.data.data.hubids;
          let tempArr = [];
          for(var i =0; i<tempHubids.length; i++){
            let hubname = this.getHubName(tempHubids[i]);
            let hubdetails = {
              'HubID': tempHubids[i],
              'HubName': hubname
            };
            tempArr.push(hubdetails);
    			}
          this.hubids = tempArr;
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    isCheck(){
      let err = 0
      if(!this.client){
        err = 1
        this.clienterr = "Select Client"
      }else{
        this.clienterr = ""
      }
      if(this.hubids.length<=0){
        err = 1
        this.huberror = 'Please Select Hub'
      }else{
        this.huberror = ''
      }
      return err
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/clienthubs/clienthubs.component.js